


















import { Component, Vue, Watch } from "vue-property-decorator";
import { AppConstants, Models, apiService, Interfaces } from "@/core/Export";
import store from "@/store";
@Component({
  components: {}
})
export default class FinishPage extends Vue {
  requestNo: number = 0;
  year: number = 0;
  isDraft = false;
  constructor() {
    super();
  }

  created() {
    this.requestNo = Number(this.$route.params.requestNo);
    this.year = Number(this.$route.params.year);
    this.isDraft =
      this.$route.query.isDraft.toString().toLowerCase() == "false"
        ? false
        : true;
    this.appEnv.canViewRequestRouteRedPage = false;
  }

  destroyed() {
    this.appEnv.isCompleteDetails = false;
  }

  get appEnv() {
    return store.getters.appEnv;
  }

  get refferResidentToDep() {
    var val;
    if (this.systemData && this.systemData["systemSettings"]) {
      val =  this.systemData["systemSettings"].refferResidentToDep;
    } 
    if(!val) val = "במרכז שירות לתושב";
    return val;
  }

  get systemData() {
    return store.getters.systemData;
  }

}
